/* The Caddie's Revenge — carousels, card flips, brush reveal */
(function () {
  function initRail(railId, dotsId, navSelector, label) {
    var rail = document.getElementById(railId);
    var dots = document.getElementById(dotsId);
    if (!rail || !dots) return;
    var items = Array.prototype.slice.call(rail.children);
    var navs  = Array.prototype.slice.call(document.querySelectorAll(navSelector));

    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to ' + label + ' ' + (i + 1) + ' of ' + items.length);
      b.addEventListener('click', function () {
        rail.scrollTo({ left: item.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    function gap() {
      return parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 16;
    }
    function stride() {
      return items[0].getBoundingClientRect().width + gap();
    }

    navs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        rail.scrollBy({ left: stride() * Number(btn.dataset.dir), behavior: 'smooth' });
      });
    });

    var queued = false;
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var x = rail.scrollLeft;
      navs.forEach(function (btn) {
        var fwd = Number(btn.dataset.dir) > 0;
        btn.disabled = fwd ? x >= max - 2 : x <= 2;
      });
      var active = 0, best = Infinity;
      items.forEach(function (item, i) {
        var d = Math.abs(item.offsetLeft - rail.offsetLeft - x);
        if (d < best) { best = d; active = i; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
      queued = false;
    }

    rail.addEventListener('scroll', function () {
      if (!queued) { queued = true; requestAnimationFrame(sync); }
    });
    window.addEventListener('resize', sync);
    sync();
  }

  initRail('tmRail',  'tmDots',  '.tm__nav',  'character');

  // tap to flip (hover handles it on pointer devices)
  document.querySelectorAll('.chr .flip').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.chr');
      var open = card.classList.toggle('is-flipped');
      btn.setAttribute('aria-pressed', open ? 'true' : 'false');
    });
  });
  initRail('htpRail', 'htpDots', '.htp__nav', 'step');

  document.querySelectorAll('.brush--centre').forEach(function (el) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('brush--draw'); io.unobserve(en.target); }
      });
    }, { threshold: 0.6 });
    io.observe(el);
  });
})();
